/**
 * Share button
 *
 * Opens the mailto link of the clicked button in a new tab, so the current
 * page keeps its state (the visitor does not lose their place on the product
 * page while the mail client opens).
 *
 * The click listener is delegated on the document, so a single registration
 * keeps working if the block is re-rendered (theme editor, section rendering)
 * and no per-instance initialisation is needed.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-share-url]');
  if (!button) return;

  const url = button.getAttribute('data-share-url');
  if (!url) return;

  window.open(url, '_blank', 'noopener');
});
